import React from "react";
import { useDispatch } from "react-redux";
import { updateProfile } from "../../../redux/profile/action";

export default function NotificationPreferencesButton({ profile }) {
  const dispatch = useDispatch();

  const handleToggle = (pref) => {
    const newStatus = pref.status == 1 ? 2 : 1;

    const data = {
      type: "notification_preferences",
      notification_preferences: {
        id: String(pref.id),
        status: String(newStatus),
      },
    };
    dispatch(updateProfile(data));
  };

  return (
    <>
      {Array.isArray(profile?.notification_preferences) &&
        profile.notification_preferences.map((pref) => (
          <div className="allow-notification" key={pref.id}>
            <h5>{pref.name}</h5>
            <div className="slide-input">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={pref.status == 1}
                  onChange={() => handleToggle(pref)}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        ))}
    </>
  );
}
